import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import CommonDialog from "../../../components/CommonDialog";
import PermissionsGate from "../../../permissions/PermissionsGate";
import { SCOPES } from "../../../permissions/permissions-map";

const steps = ["Unassigned", "Assigned", "Work in progress"];
const Data = [
  { ConfigKey: 1, ConfigValue: "Unassigned" },
  { ConfigKey: 2, ConfigValue: "Assigned" },
  { ConfigKey: 3, ConfigValue: "Work in progress" },
  { ConfigKey: 4, ConfigValue: "Completed" },
];

export default function ProjectStatus(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [checked, setChecked] = React.useState(false);
  const [showChangeDialog, setShowChangeDialog] = React.useState(false);
  const [showRevertDialog, setShowRevertDialog] = React.useState(false);

  React.useEffect(() => {
    props.getProjectStatus(Data[activeStep].ConfigKey);
    props.isProjectPending(checked);
  }, [activeStep, checked, props]);

  const dialogMsg = (param) => {
    switch (param) {
      case 0:
        return "Are you sure, you want to mark 'Unassigned' status as completed";
      case 1:
        return "Are you sure, you want to mark 'Assigned' status as completed";
      case 2:
        return "Are you sure, you want to mark the project as completed";
      default:
        return "Are you sure, you want to mark the project as completed";
    }
  };

  const revertButtonSx = {
    ml: 3,
    ...(activeStep === 0 && { display: "none" }),
  };
  const completedMessageSx = {
    ...(activeStep === steps.length
      ? {
          display: "flex",
          justifyContent: "center",
        }
      : {
          display: "none",
        }),
  };
  const hideOnCompletedSx = {
    ml: 3,
    ...(activeStep === steps.length && { display: "none" }),
  };

  const handleDialogOpen = () => {
    setShowChangeDialog(true);
  };
  const handleDialogClose = React.useCallback(() => {
    setShowChangeDialog(false);
  }, []);
  const handleDialogDone = React.useCallback(() => {
    handleDialogClose();
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, [handleDialogClose]);

  const handleRevertDialogOpen = () => {
    setShowRevertDialog(true);
  };
  const handleRevertDialogClose = React.useCallback(() => {
    setShowRevertDialog(false);
  }, []);
  const handleRevertDialogDone = React.useCallback(() => {
    handleRevertDialogClose();
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }, [handleRevertDialogClose]);

  return (
    <Box sx={{ display: "inline", width: "100%" }}>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ my: 2 }}>
        {steps.map((label) => (
          <Step key={label} value={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <PermissionsGate scopes={[SCOPES.canCreate]}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            my: 3,
            mt: 6,
          }}
        >
          <Box sx={completedMessageSx}>
            <Typography
              component="p"
              sx={{
                color: "success.main",
                fontWeight: "bold",
              }}
            >
              PROJECT IS COMPLETED
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mr: 3 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  onChange={(e) => {
                    setChecked(e.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Pending"
              labelPlacement="start"
              sx={hideOnCompletedSx}
            />
            <Button
              variant="contained"
              disabled={checked}
              sx={revertButtonSx}
              onClick={handleRevertDialogOpen}
            >
              Revert Status
            </Button>
            <Button
              variant="contained"
              disabled={checked}
              sx={hideOnCompletedSx}
              onClick={handleDialogOpen}
            >
              Completed
            </Button>
          </Box>
        </Box>
      </PermissionsGate>
      <CommonDialog
        open={showRevertDialog}
        title="Revert Project Status"
        content={"Are you sure, you want to revert the changes?"}
        type="yesNo"
        handleClose={handleRevertDialogClose}
        handleDone={handleRevertDialogDone}
      />
      <CommonDialog
        open={showChangeDialog}
        title="Change Project Status"
        content={dialogMsg(activeStep)}
        type="yesNo"
        handleClose={handleDialogClose}
        handleDone={handleDialogDone}
      />
    </Box>
  );
}
